import SectionTitle, {
  SectionTitleProps,
} from 'src/components/ui/SectionTitle';
import { twMerge } from 'tailwind-merge';

import type { ReactNode } from 'react';

interface PageTitleProps extends SectionTitleProps {
  actionSlot?: ReactNode;
}

const PageTitle = ({
  title,
  level = 2,
  className,
  children,
  actionSlot,
}: PageTitleProps) => {
  return (
    <div
      className={twMerge(
        'flex items-center justify-between bg-surface-alt px-4 py-1.5 min-h-14 shadow-3 rounded-xl',
        className
      )}
    >
      <SectionTitle
        title={title}
        level={level}
        className="block p-0"
        titleClassName="text-xl text-surface-alt-75"
      >
        {children}
      </SectionTitle>
      {actionSlot}
    </div>
  );
};

export default PageTitle;
